var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{class:_vm.$style['info-item']},[_c('span',{class:_vm.$style['label']},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',{class:_vm.$style['value']},[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_vm._t("extra")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }